/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// WAVESURFER CODE

$(theme.init);

var wavesurfers = [];

$(".wave-form").each(function(){
    
    var t = $(this), id = '#' + t.attr('id'), src= t.data('src'), waveColor = t.data('color-wave'), progressColor = t.data('color-prog');
    console.log(src);
	var waveOptions = {
  		container: document.querySelector(id),
  		waveColor: waveColor,
  		progressColor: progressColor,
      	height: 40,
      	fillParent: true,
	};
  
  	var wavesurfer = WaveSurfer.create(waveOptions);
  	wavesurfer.load(src);
//   	console.log(wavesurfer)
    
  	var waveStart =  t.parent('.wave').find("#start");
  	var wavePause = t.parent('.wave').find("#pause");
  	wavesurfers.push({id: id, wavesurfer: wavesurfer, wavePause: wavePause, waveStart: waveStart});
  	wavePause.hide();
    
  	waveStart.click(function() {
       	console.log(wavesurfers)
        wavesurfers.forEach(stopAudios);
  		wavesurfer.play();
  		waveStart.hide();
  		wavePause.show();
	});
  	wavePause.click(function() {
  		wavesurfer.pause();
  		waveStart.show();
  		wavePause.hide();
  	});
  
  	function stopAudios(item, index){
      if(id !== item.id){
   //   	item.wavesurfer.pause();
       item.wavesurfer.stop();
		item.wavePause.hide();
        item.waveStart.show();
      }
  	}
});

// WAVESURFER CODE